import { useCallback } from "react";

export interface IRadioButtonFilterGroupLogicPram<AvailableValues extends string = string> {
  onChange?: (newValue: AvailableValues) => void;
  value?: AvailableValues;
}
export interface IRadioButtonFilterGroupLogic<AvailableValues extends string = string> {
  onChangeHandler: (newValue: AvailableValues) => void;
  isOptionSelected: (optionValue: AvailableValues) => boolean;
}

export const useRadioButtonFilterGroupLogic = <AvailableValues extends string = string>({onChange, value} : IRadioButtonFilterGroupLogicPram<AvailableValues>): IRadioButtonFilterGroupLogic<AvailableValues> => {

  const onChangeHandler = useCallback((newValue: AvailableValues) => {
    if (typeof onChange === "undefined") {
      // no callback passed, nothing to do
      // return to exit
      return;
    }

    if ((value ?? ``) === newValue) {
      // nothing changed, nothing to do
      // return to exit
      return;
    }
    onChange(newValue);
  }, [value, onChange]);

  const isOptionSelected = useCallback(
    (optionValue: string) => (value ?? ``) === optionValue,
    [value]
  );

  return {
    onChangeHandler,
    isOptionSelected
  };
}
